import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { SYSTEM_STEPS } from "../data/site";

function Word({ word, i, total, progress, isLast }) {
  const seg = 1 / total;
  const start = i * seg;
  const mid = start + seg / 2;
  const end = start + seg;

  const opIn = [start - 0.04, start + 0.03, end - 0.03, end + 0.02];
  const opOut = isLast ? [0, 1, 1, 1] : [0, 1, 1, 0];
  const opacity = useTransform(progress, opIn, opOut);

  const scale = useTransform(
    progress,
    [start - 0.04, end + 0.02],
    isLast ? [0.9, 1.15] : [1.1, 0.85]
  );
  const blur = useTransform(
    progress,
    [start - 0.05, start + 0.03, end - 0.03, end + 0.03],
    isLast ? [8, 0, 0, 0] : [10, 0, 0, 10]
  );
  const filter = useTransform(blur, (b) => `blur(${b}px)`);

  return (
    <motion.span
      style={{ opacity, scale, filter }}
      className={`col-start-1 row-start-1 text-display uppercase ${
        isLast ? "text-lav-400" : "text-white"
      }`}
    >
      {word}
    </motion.span>
  );
}

export default function SystemAnimation() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start start", "end end"],
  });
  const total = SYSTEM_STEPS.length;
  const step = useTransform(scrollYProgress, (p) =>
    Math.min(total - 1, Math.floor(p * total))
  );

  return (
    <section ref={ref} id="system" className="relative h-[400vh]" data-testid="system">
      <div className="sticky top-0 flex h-[100svh] flex-col items-center justify-center overflow-hidden">
        <div className="pointer-events-none absolute top-[12%] label text-lav-400">
          05 — CONTENT IS A SYSTEM
        </div>

        <div className="grid place-items-center px-6 text-center">
          {SYSTEM_STEPS.map((w, i) => (
            <Word
              key={w}
              word={w}
              i={i}
              total={total}
              progress={scrollYProgress}
              isLast={i === total - 1}
            />
          ))}
        </div>

        {/* step ticks */}
        <div className="absolute bottom-[12%] flex items-center gap-3">
          {SYSTEM_STEPS.map((w, i) => (
            <Tick key={w} i={i} step={step} />
          ))}
        </div>
      </div>
    </section>
  );
}

function Tick({ i, step }) {
  const backgroundColor = useTransform(step, (s) =>
    s === i ? "#A78BFA" : "rgba(255,255,255,0.15)"
  );
  return (
    <motion.div
      className="h-1 w-10 rounded-full bg-white/15"
      style={{ backgroundColor }}
    />
  );
}
